import HoursSetupEditor from "../../components/HoursSetupEditor";

export default function MerchantHours() {
    return <HoursSetupEditor apiPrefix="/merchant" testidPrefix="hours" />;
}
